import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    helper: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    text: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'hidden',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
    },
    select: {
        border: 0,
        background: '#293356',
        boxShadow: 'inset 0 1px 0 0 hsl(0deg 0% 100% / 20%)',
        paddingLeft: 8,
        borderRadius: '4px',
        color: '#fff',
        cursor: 'pointer',
        display: 'table',
        borderSpacing: 0,
        borderCollapse: 'initial',
        height: '32px',
        outline: 'none',
        overflow: 'hidden',
        position: 'relative',
        width: '420px'
    },
    root: {
        color: '#fff', 
        height: 'calc(100vh - 78px)',
        overflowY: 'scroll',
        '::-webkit-scrollbar': {
            width: 0,
        }
    },
    wrapLabel: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 12,
        marginBottom: 24,
    },
    nameBonusLabel: {
        width: 420,
    },
    beginBonusLabel: {
        width: '32%', 
    },
    titleGroup: {
        borderBottom: '1px solid rgb(204, 204, 204)', 
        paddingBottom: 8, 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        cursor: 'pointer', 
        marginBottom: 12
    },
    arrowGroup: {
        fill: '#fff',
        width: 15,
        height: 15,
    },
    headerGroup: {
        padding: 0, 
        margin: 0, 
        userSelect: 'none',
    },
    mt0: {
        marginTop: 0
    },
    textarea: {
        color: '#fff',
        background: 'rgba(68,88,143,.5)',
        border: 0,
        borderRadius: '4px',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        padding: '6px',
        minWidth: '40px',
        width: '100%',
        height: '140px',
        resize: 'none',
        outline: 'none'
    },
    wrapTextarea: {
        display: 'flex', 
        flexDirection: 'column', 
        width: '49%', 
        marginBottom: 12
    },
    wrapBlockTextarea: {
        display: 'flex', 
        justifyContent: 'space-between', 
        flexWrap: 'wrap'
    },
    wrapActiveBonus: {
        display: 'flex', 
        justifyContent: 'space-between', 
        width: '70%'
    },
    wrapDialog: {
        width: 250, 
        height: 100, 
        padding: 20, 
        display: 'flex', 
        flexDirection: 'column'
    },
    titleDialog: {
        textAlign: 'center'
    },
    errorTitleDialog: {
        fontWeight: 700,
        color: 'red',
    },
    dialogButton: {
         color: 'rgb(36, 38, 62)',
        background: 'rgb(255, 206, 1)',
        border: '1px solid rgb(255, 206, 1)',
        padding: '5px 10px',
        borderRadius: '16px',
        maxHeight: '48px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'uppercase',
        fontSize: 14,
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none',
        cursor: 'pointer',
        fontWeight: 700,
        textAlign: 'center'
    }
}))

export {
    useStyles
}